'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "icon", "_useNativeButton"];
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import BeakerIcon from './BeakerIcon';
import UIFloatingActionButton from '../UIFloatingActionButton';
import { CALYPSO, CALYPSO_DARK, OLAF, OZ } from 'HubStyleTokens/colors';
import HoverProvider from '../../providers/HoverProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const hoveredStyles = css(["color:", ";background-color:", ";"], OLAF, CALYPSO_DARK);
const blueOceanGradient = css(["color:", ";background-color:", ";background-image:linear-gradient(89deg,", ",", ") !important;"], OLAF, CALYPSO, CALYPSO, OZ);
const BetaTheme = styled(UIFloatingActionButton).withConfig({
  displayName: "UIBetaButton__BetaTheme",
  componentId: "sc-1s34jh7-0"
})(["", ""], props => props.hovered ? hoveredStyles : blueOceanGradient);
const StyledBeakerIcon = styled(BeakerIcon).withConfig({
  displayName: "UIBetaButton__StyledBeakerIcon",
  componentId: "sc-1s34jh7-1"
})(["height:54px;left:0;position:absolute;top:-24px;width:20px;"]);
const Inner = styled.span.withConfig({
  displayName: "UIBetaButton__Inner",
  componentId: "sc-1s34jh7-2"
})(["padding-left:", ";position:relative;"], props => props.icon === 'beaker' ? '26px' : 0);
const UIBetaButton = props => {
  const {
      children,
      icon
      // No-op prop received when used as a UIDropdown button
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(HoverProvider, Object.assign({}, props, {
    children: hoverProviderProps => /*#__PURE__*/_jsx(BetaTheme, Object.assign({}, rest, hoverProviderProps, {
      children: /*#__PURE__*/_jsxs(Inner, {
        icon: icon,
        children: [icon === 'beaker' ? /*#__PURE__*/_jsx(StyledBeakerIcon, {}) : null, children]
      })
    }))
  }));
};
UIBetaButton.propTypes = Object.assign({}, UIFloatingActionButton.propTypes, {
  icon: PropTypes.oneOf(['beaker', 'none'])
});

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIBetaButton.defaultProps = Object.assign({}, UIFloatingActionButton.defaultProps, {
  icon: 'beaker'
});
UIBetaButton.displayName = 'UIBetaButton';
export default UIBetaButton;